@for (fileInfo of files; track fileInfo) {
  <glxy-image-upload-tile
    [file]="fileInfo?.data?.croppedImage || fileInfo.file"
    [url]="fileInfo.url"
    [status]="fileInfo.status"
    [showDeleteButton]="delete.observers.length > 0"
    [showEditButton]="edit.observers.length > 0"
    (edit)="editClick(fileInfo)"
    (delete)="deleteClick(fileInfo)"
  />
}
